import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("导出");

import { ref } from 'vue';
import { getSalesmanApplyList, exportForAsync } from '@/request';
import { getVexTableProps, dateFormat } from '@/config';
import dayjs from 'dayjs';
import { isNullOrDefined } from '@/utils/tools';
export default {
  name: 'SalesmanRegisterApplyQuery',

  setup(__props) {
    const form = ref({
      salesmanKeyWord: '',
      supplierName: '',
      fromSupUser: '',
      auditState: '',
      endTime: dayjs(Date.now()).format(dateFormat),
      startTime: dayjs(Date.now() - 30 * 24 * 60 * 60 * 1000).format(dateFormat)
    });
    const formRef = ref();
    let total = 0;
    const exportAuth = ref(false);
    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        title: '状态',
        field: 'auditState',
        width: '150px'
      }, // {
      //   title: '登录账号/联系电话',
      //   field: 'loginName',
      //   width: '200px',
      //   showOverflow: true
      // },
      {
        title: '申请人姓名',
        field: 'registrantName',
        width: '150px'
      }, {
        title: '申请加入团队',
        field: 'supplierName',
        width: '200px',
        showOverflow: true
      }, {
        title: '团队业务区域',
        field: 'businessAreaName',
        width: '250px',
        showOverflow: true
      }, {
        title: '申请理由',
        field: 'remark',
        width: '200px',
        showOverflow: true
      }, // {
      //   title: '邀请人账号',
      //   field: 'fromSupLoginName',
      //   width: '150px',
      //   showOverflow: true
      // },
      {
        title: '邀请人姓名',
        field: 'fromSupLinkMan',
        width: '150px',
        showOverflow: true
      }, {
        title: '拒绝理由',
        field: 'refuseReason',
        width: '200px',
        showOverflow: true
      }, {
        title: '申请时间',
        field: 'createAt',
        width: '200px'
      }, {
        title: '加入时间',
        field: 'joinAt',
        width: '200px'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getSalesmanApplyList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value)).then(data => {
              total = data.total;
              exportAuth.value = data.exportAuth;
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    const table = ref();

    function reset() {
      formRef.value.resetFields();
      table.value.commitProxy('reload');
    }

    function exportHandle() {
      let body = _objectSpread({}, form.value);

      if (isNullOrDefined(body.startTime)) {
        body.startTime = '';
      }

      if (isNullOrDefined(body.endTime)) {
        body.endTime = '';
      }

      exportForAsync(_objectSpread({
        count: total,
        fileName: '业务员注册申请列表明细',
        modularflag: 'userRegisterApply',
        methodName: '/admin/userRegistApply/exportUserRegistApplyList.json'
      }, body));
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        model: form.value,
        ref_key: "formRef",
        ref: formRef,
        "label-width": "100px",
        onKeydown: _cache[6] || (_cache[6] = _withKeys($event => table.value.commitProxy('reload'), ["enter"]))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "申请人",
              prop: "salesmanKeyWord"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.salesmanKeyWord,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.salesmanKeyWord = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "申请加入团队",
              prop: "supplierName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.supplierName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.supplierName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "邀请人",
              prop: "fromSupUser"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.fromSupUser,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.fromSupUser = $event),
                placeholder: "账号/姓名"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "状态",
              prop: "auditState"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.auditState,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.auditState = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "待审核",
                  value: "0"
                }), _createVNode(_component_el_option, {
                  label: "已同意",
                  value: "2"
                }), _createVNode(_component_el_option, {
                  label: "已拒绝",
                  value: "1"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "开始时间",
              prop: "startTime"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.startTime,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.startTime = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "开始时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "结束时间",
              prop: "endTime"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.endTime,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.endTime = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "结束时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[7] || (_cache[7] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
        ref_key: "table",
        ref: table
      }), {
        tools: _withCtx(() => [exportAuth.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          icon: "download",
          onClick: exportHandle
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 16)]);
    };
  }

};